import { render } from "./ErrorFallback.vue?vue&type=template&id=468560e6&scoped=true"
import script from "./ErrorFallback.vue?vue&type=script&lang=js"
export * from "./ErrorFallback.vue?vue&type=script&lang=js"

import "./ErrorFallback.vue?vue&type=style&index=0&id=468560e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468560e6"]])

export default __exports__